// src/redux/themeSlice.js

import { createSlice } from "@reduxjs/toolkit";

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    currentTheme: {
      colorBgBase: "#ffffff",
      colorPrimary: "#b8860b",
      colorInfo: "#b8860b",
      colorLink: "#8a6508",
      colorTextBase: "#000000",
      colorSuccess: "#16a34a",
      colorWarning: "#ca8a04",
      colorError: "#dc2626",
      colorBgHeader: "red",
    }
  },
  reducers: {
    setCurrentTheme: (state, action) => {
      state.currentTheme = action.payload;
    },
  },
});

export const { setCurrentTheme } = themeSlice.actions;
export default themeSlice.reducer;
